import { Icono } from './Icono';
import type { NombreIcono } from './iconos';
import './eleccion.css';

/**
 * RV Pasos (componentes.md, tabla de piezas): procesos en varios pasos (importar clientes). Volver «‹» + puntos (el activo
 * se alarga) + el botón del paso: «Siguiente» o el que dé la pantalla y, en el último, el de terminar con su icono. En el
 * primer paso no hay «‹» (su hueco se queda). `inactivo` lo deja al 40 % y al tocarlo llama a `onInactivo` (para decir
 * qué falta); `ocupado` gira el icono y pasa el texto al gerundio.
 */
interface Props {
    total: number;
    valor: number;
    onCambio: (paso: number) => void;
    onFin: () => void;
    siguiente?: string;
    terminar: string;
    icono?: NombreIcono;
    inactivo?: boolean;
    onInactivo?: () => void;
    ocupado?: boolean;
    ocupadoTexto?: string;
    movil?: boolean;
    /** Sin «‹» aunque no sea el primer paso (p. ej. mientras sube el archivo). */
    sinVolver?: boolean;
}

export function Pasos({ total, valor, onCambio, onFin, siguiente = 'Siguiente', terminar, icono = 'check', inactivo = false, onInactivo, ocupado = false, ocupadoTexto, movil = false, sinVolver = false }: Props) {
    const ultimo = valor >= total - 1;
    const texto = ultimo ? terminar : siguiente;
    const pulsar = () => {
        if (ocupado) {
            return;
        }
        if (inactivo) {
            onInactivo?.();
            return;
        }
        if (ultimo) {
            onFin();
        } else {
            onCambio(valor + 1);
        }
    };
    return (
        <div className={`rv-pasos${movil ? ' rv-pasos--movil' : ''}`}>
            <span className="rv-pasos__volver">
                {valor > 0 && !sinVolver && (
                    <button
                        type="button"
                        className="rv-bi rv-pasos__atras"
                        aria-label="Paso anterior"
                        disabled={ocupado}
                        onClick={() => {
                            onCambio(valor - 1);
                        }}
                    >
                        <Icono nombre="chevron-left" />
                    </button>
                )}
            </span>
            <span className="rv-pasos__puntos" aria-label={`Paso ${String(valor + 1)} de ${String(total)}`} role="img">
                {Array.from({ length: total }, (_, i) => (
                    <span key={i} className={`rv-pasos__punto${i === valor ? ' rv-pasos__punto--on' : i < valor ? ' rv-pasos__punto--hecho' : ''}`} />
                ))}
            </span>
            <button
                type="button"
                className={`rv-b rv-b-pri${movil ? ' rv-b--movil' : ''} rv-pasos__accion`}
                aria-disabled={inactivo ? true : undefined}
                aria-busy={ocupado ? true : undefined}
                style={{ opacity: inactivo ? 0.4 : 1 }}
                onClick={pulsar}
            >
                {ocupado && <Icono nombre="loader-circle" tamano={18} className="rv-gira" />}
                {!ocupado && ultimo && <Icono nombre={icono} />}
                <span>{ocupado && ocupadoTexto !== undefined ? ocupadoTexto : texto}</span>
                {!ocupado && !ultimo && <Icono nombre="chevron-right" />}
            </button>
        </div>
    );
}
